import { render, staticRenderFns } from "./record-dialog.vue?vue&type=template&id=d139d9ac&scoped=true&"
import script from "./record-dialog.vue?vue&type=script&lang=js&"
export * from "./record-dialog.vue?vue&type=script&lang=js&"
import style0 from "./record-dialog.vue?vue&type=style&index=0&id=d139d9ac&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d139d9ac",
  null
  
)

export default component.exports